import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router';

import {
  about,
  buyersProfile,
  clubs,
  contact,
  figureSkatingPath,
  gallery,
  nationalChampionships,
  nationalTeam,
  ncRules,
  news,
  regulations,
  rules,
  safeguarding,
  shorttrackPath,
  team,
  volunteers,
} from './components/constants/links';

import LandingPage from './pages/landing-page';

const ScrollToTop = lazy(() => import('./components/scroll-to-top'));
const ScrollTopButton = lazy(() => import('./components/scroll-top-button'));

const AboutPageFs = lazy(() => import('./pages/figure-skating/about.page'));
const BuyersProfilePageFs = lazy(() => import('./pages/figure-skating/buyers-profile.page'));
const ClubsPageFs = lazy(() => import('./pages/figure-skating/clubs.page'));
const ContactPageFs = lazy(() => import('./pages/figure-skating/contact.page'));
const GalleryPageFs = lazy(() => import('./pages/figure-skating/gallery.page'));
const FigureSkatingPage = lazy(() => import('./pages/figure-skating/figure-skating.page'));
const NationalChampionshipsPageFs = lazy(() => import('./pages/figure-skating/national-championships.page'));
const NationalChampionshipsRulesPageFs = lazy(() => import('./pages/figure-skating/national-championships-rules.page'));
const NationalTeamPageFs = lazy(() => import('./pages/figure-skating/national-team.page'));
const NewsPageFs = lazy(() => import('./pages/figure-skating/news.page'));
const RegulationsPageFs = lazy(() => import('./pages/figure-skating/regulations.page'));
const RulesPageFs = lazy(() => import('./pages/figure-skating/rules.page'));
const TeamPageFs = lazy(() => import('./pages/figure-skating/team.page'));
const VolunteersPageFs = lazy(() => import('./pages/figure-skating/volunteers.page'));
const AboutPageSt = lazy(() => import('./pages/shorttrack/about.page'));
const SafeguardingPageFs = lazy(() => import('./pages/figure-skating/safeguarding.page'));
const SafeguardingPageSt = lazy(() => import('./pages/shorttrack/safeguarding.page'));
const BuyersProfilePageSt = lazy(() => import('./pages/shorttrack/buyers-profile.page'));
const ClubsPageSt = lazy(() => import('./pages/shorttrack/clubs.page'));
const ContactPageSt = lazy(() => import('./pages/shorttrack/contact.page'));
const GalleryPageSt = lazy(() => import('./pages/shorttrack/gallery.page'));
const NationalChampionshipsPageSt = lazy(() => import('./pages/shorttrack/national-championships.page'));
const NationalChampionshipsRulesPageSt = lazy(() => import('./pages/shorttrack/national-championships-rules.page'));
const NationalTeamPageSt = lazy(() => import('./pages/shorttrack/national-team.page'));
const NewsPageSt = lazy(() => import('./pages/shorttrack/news.page'));
const RegulationsPageSt = lazy(() => import('./pages/shorttrack/regulations.page'));
const RulesPageSt = lazy(() => import('./pages/shorttrack/rules.page'));
const ShorttrackPage = lazy(() => import('./pages/shorttrack/shorttrack.page'));
const TeamPageSt = lazy(() => import('./pages/shorttrack/team.page'));
const VolunteersPageSt = lazy(() => import('./pages/shorttrack/volunteers.page'));

import { PageNotFound } from 'page-not-found';
import 'page-not-found/page-not-found.css';

import './App.scss';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path={figureSkatingPath}>
            <Route index element={<FigureSkatingPage />} />
            <Route path={about} element={<AboutPageFs />} />
            <Route path={clubs} element={<ClubsPageFs />} />
            <Route path={nationalTeam} element={<NationalTeamPageFs />} />
            <Route path={team} element={<TeamPageFs />} />
            <Route path={regulations} element={<RegulationsPageFs />} />
            <Route path={rules} element={<RulesPageFs />} />
            <Route path={safeguarding} element={<SafeguardingPageFs />} />
            <Route path={buyersProfile} element={<BuyersProfilePageFs />} />
            <Route path={news} element={<NewsPageFs />} />
            <Route path={nationalChampionships}>
              <Route index element={<NationalChampionshipsPageFs />} />
              <Route path={ncRules} element={<NationalChampionshipsRulesPageFs />} />
            </Route>
            <Route path={gallery} element={<GalleryPageFs />} />
            <Route path={contact} element={<ContactPageFs />} />
            <Route path={volunteers} element={<VolunteersPageFs />} />
          </Route>
          <Route path={shorttrackPath}>
            <Route index element={<ShorttrackPage />} />
            <Route path={about} element={<AboutPageSt />} />
            <Route path={clubs} element={<ClubsPageSt />} />
            <Route path={nationalTeam} element={<NationalTeamPageSt />} />
            <Route path={team} element={<TeamPageSt />} />
            <Route path={regulations} element={<RegulationsPageSt />} />
            <Route path={rules} element={<RulesPageSt />} />
            <Route path={safeguarding} element={<SafeguardingPageSt />} />
            <Route path={buyersProfile} element={<BuyersProfilePageSt />} />
            <Route path={news} element={<NewsPageSt />} />
            <Route path={nationalChampionships}>
              <Route index element={<NationalChampionshipsPageSt />} />
              <Route path={ncRules} element={<NationalChampionshipsRulesPageSt />} />
            </Route>
            <Route path={gallery} element={<GalleryPageSt />} />
            <Route path={contact} element={<ContactPageSt />} />
            <Route path={volunteers} element={<VolunteersPageSt />} />
          </Route>
          <Route path="*" element={<PageNotFound lang="bg" />} />
        </Routes>
      </Suspense>
      <ScrollTopButton />
    </BrowserRouter>
  );
}

export default App;
